<script>
/* -------------------------------------------------------------------------------------
The footer component displays relevant information at the bottom of the site

Main components
---------------
Methods:
- 
---------------------------------------------------------------------------------------*/

import NotifBar from '@/components/NotifBar.vue'
import { mapState } from 'vuex'

export default {
  components: {
    NotifBar // this component displays the notifications on the right
  },
  data() {
    return {
      api_url: process.env.VUE_APP_API_URL,
      env: process.env.VUE_APP_ENV,
      version: process.env.VUE_APP_VERSION,
    }
  },

  computed: mapState('notification', ['notifications'])
}
</script>

<template>
  <v-footer class="footer-containter">
    <v-layout justify-left wrap>
      <v-col cols="6" class="pa-0">
        <v-card class="footer-logo">
          <p>&copy; tourdb 2021 leuti - {{ env }} / v{{ version }}</p>
        </v-card>
      </v-col>
      <v-col cols="6" class="pa-0">
        <div class="footer-notification font-weight-bold">
          <NotifBar
            v-for="notification in notifications"
            :key="notification.id"
            :notification="notification"
          />
        </div>
      </v-col>
    </v-layout>
  </v-footer>
</template>

<style scoped>
.footer-containter {
  position: fixed;
  left: 0px;
  bottom: 0px;
  height: 0px;
  width: 100%;
  padding-left: 20px;
  padding-bottom: 25px;
  /*color: rgb(177, 194, 218);*/
}

/*.footer-logo {
  float: left;
}*/
</style>
